import type { PreviewOriginEntity } from "./cells/ApplyCoaPreviewNameCell";
import {
    ApplyCoaPreviewOriginSource,
    ApplyCoaPreviewSource,
    ApplyCoaPreviewUpdate,
} from "./applyCoaTemplatePreviewStatus";

// Tab keys for the preview's "Add filter" popover. Shared between the overlay
// (ApplyCoaPreviewFilters) and the active-filter chips
// (ApplyCoaPreviewActiveFilters) so a chip click reopens the matching tab.
export const ORIGIN_TAB = "origin";
export const UPDATES_TAB = "updates";
export const SOURCE_TAB = "source";

// String-labeled option shape (assignable to MultiselectOption) so the same
// arrays drive the popover multiselects and the chip labels without casting.
interface PreviewFilterOption<TValue extends string> {
    value: TValue;
    label: string;
    searchableLabel?: string;
}

export const UPDATE_OPTIONS: Array<PreviewFilterOption<ApplyCoaPreviewUpdate>> =
    [
        { value: ApplyCoaPreviewUpdate.addedAccount, label: "Added account" },
        { value: ApplyCoaPreviewUpdate.addedGroup, label: "Added group" },
        {
            value: ApplyCoaPreviewUpdate.reassignedAccount,
            label: "Reassigned account",
        },
        { value: ApplyCoaPreviewUpdate.moved, label: "Moved" },
        { value: ApplyCoaPreviewUpdate.active, label: "Active" },
        { value: ApplyCoaPreviewUpdate.archived, label: "Archived" },
    ];

export const SOURCE_OPTIONS: Array<PreviewFilterOption<ApplyCoaPreviewSource>> =
    [
        { value: ApplyCoaPreviewSource.custom, label: "Custom" },
        { value: ApplyCoaPreviewSource.kick, label: "Kick" },
    ];

// Human labels for the active-filter chips. Origin and Updates are multi-select,
// so their selected values are joined; the entity origin source shows the
// previewed company's name (falling back to "Entity" when none is in context).
export function getPreviewOriginLabel(
    sources: ApplyCoaPreviewOriginSource[],
    originEntity: PreviewOriginEntity | undefined,
): string {
    return sources
        .map((source) =>
            source === ApplyCoaPreviewOriginSource.template
                ? "Template"
                : (originEntity?.name ?? "Entity"),
        )
        .join(", ");
}

export function getPreviewUpdatesLabel(
    updates: ApplyCoaPreviewUpdate[],
): string {
    return updates
        .map(
            (update) =>
                UPDATE_OPTIONS.find((option) => option.value === update)
                    ?.label ?? update,
        )
        .join(", ");
}

export function getPreviewSourceLabel(
    source: ApplyCoaPreviewSource,
): string | undefined {
    return SOURCE_OPTIONS.find((option) => option.value === source)?.label;
}
